import { getDoughnutSettings } from "./helper.ts";
import type { ChartStyleSettings } from "../../../../../../../api/types/svTypes.ts";

export function getThickness(settings: ChartStyleSettings): number {
  return getDoughnutSettings(settings)?.thickness || 0.5;
}
